module.exports = __webpack_public_path__ + "img/2018-09-07.fc68aed2.jpg";